import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categories-content',
  templateUrl: './categories-content.component.html',
  styleUrls: ['./categories-content.component.scss']
})
export class CategoriesContentComponent implements OnInit {
  categories = [
    {img: './../../../../../assets/images/33.png', title: 'ادوات التجميل'},
    {img: './../../../../../assets/images/202.png', title: 'الكترونيات'},
    {img: './../../../../../assets/images/123.png', title: 'الملابس'},
    {img: './../../../../../assets/images/33.png', title: 'ادوات التجميل'},
    {img: './../../../../../assets/images/202.png', title: 'الكترونيات'},
    {img: './../../../../../assets/images/123.png', title: 'الملابس'},
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
